export default __webpack_public_path__ + "static/media/36I-102812_-16846_0.d9225917.jpg";